import cn from 'classnames'
import styled from 'styled-components'
import tw from 'twin.macro'

export const FieldContainer = styled.div`
  ${(props) => (props.isHidden ? tw`w-full mb-4 hidden` : tw`w-full mb-4`)};
  ${(props) => props.css}
`
